/**
 * Vantage Core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ClaimProviderViewModel } from './claimProviderViewModel';
import { HoldingIssue } from './holdingIssue';
import { ClaimLocationViewModel } from './claimLocationViewModel';

export interface ClaimVisitViewModel {
  visitIdentifier?: string | null;
  illnessInjuryDate?: string | null;
  accidentType?: string | null;
  accidentStateCode?: string | null;
  hospitalAdmitDate?: string | null;
  hospitalDischargeDate?: string | null;
  diagnoses?: Array<string> | null;
  delayReason?: string | null;
  frequency?: string | null;
  pwkReportTypeCode?: string | null;
  pwkTransmissionCode?: string | null;
  pwkAttachmentNumber?: string | null;
  primaryInsuranceAuthNumber?: string | null;
  secondaryInsuranceAuthNumber?: string | null;
  tertiaryInsuranceAuthNumber?: string | null;
  releaseOfInformationCode?: string | null;
  patientSignatureSourceCode?: string | null;
  admitHour?: number | null;
  dischargeHour?: number | null;
  visitBox17AQualifier?: string | null;
  visitBox17AValue?: string | null;
  visitBox9bValue?: string | null;
  visitBox9cValue?: string | null;
  claimComment?: string | null;
  visitAttendingProviderDetails?: ClaimProviderViewModel;
  visitReferringProviderDetails?: ClaimProviderViewModel;
  visitOrderingProviderDetails?: ClaimProviderViewModel;
  visitSupervisingProviderDetails?: ClaimProviderViewModel;
  visitLocationDetails?: ClaimLocationViewModel;
  visitProcedureAmount?: number;
  visitPaymentAmount?: number;
  visitSendClia?: boolean;
  visitSendMammo?: boolean;
  visitDiagnoses?: Array<string> | null;
  visitSendOrdering?: boolean;
  visitSuppressBox17?: boolean;
  admissionTypeCode?: string | null;
  admissionSourceCode?: string | null;
  dischargeStatusCode?: string | null;
  billingNote?: string | null;
  claimNoteType1?: string | null;
  claimNote1?: string | null;
  claimNoteType2?: string | null;
  claimNote2?: string | null;
  claimNoteType3?: string | null;
  claimNote3?: string | null;
  claimNoteType4?: string | null;
  claimNote4?: string | null;
  claimNoteType5?: string | null;
  claimNote5?: string | null;
  claimNoteType6?: string | null;
  claimNote6?: string | null;
  claimNoteType7?: string | null;
  claimNote7?: string | null;
  claimNoteType8?: string | null;
  claimNote8?: string | null;
  claimNoteType9?: string | null;
  claimNote9?: string | null;
  claimNoteType10?: string | null;
  claimNote10?: string | null;
  admittingDiagnosisCode?: string | null;
  admittingDiagPresentOnAdmission?: string | null;
  visitReason1DiagnosisCode?: string | null;
  visitReason1PresentOnAdmission?: string | null;
  visitReason2DiagnosisCode?: string | null;
  visitReason2PresentOnAdmission?: string | null;
  visitReason3DiagnosisCode?: string | null;
  visitReason3PresentOnAdmission?: string | null;
  cause1DiagnosisCode?: string | null;
  cause1PresentOnAdmission?: string | null;
  cause2DiagnosisCode?: string | null;
  cause2PresentOnAdmission?: string | null;
  cause3DiagnosisCode?: string | null;
  cause3PresentOnAdmission?: string | null;
  drgDiagnosisCode?: string | null;
  drgPresentOnAdmission?: string | null;
  principalProcedure?: string | null;
  principalProcedureDate?: string | null;
  otherProcedure1Code?: string | null;
  otherProcedure1Date?: string | null;
  otherProcedure2Code?: string | null;
  otherProcedure2Date?: string | null;
  otherProcedure3Code?: string | null;
  otherProcedure3Date?: string | null;
  otherProcedure4Code?: string | null;
  otherProcedure4Date?: string | null;
  otherProcedure5Code?: string | null;
  otherProcedure5Date?: string | null;
  occurrenceSpanCode1Code?: string | null;
  occurrenceSpan1FromDate?: string | null;
  occurrenceSpan1ToDate?: string | null;
  occurrenceSpanCode2Code?: string | null;
  occurrenceSpan2FromDate?: string | null;
  occurrenceSpan2ToDate?: string | null;
  occurrenceCode1Code?: string | null;
  occurrence1Date?: string | null;
  occurrenceCode2Code?: string | null;
  occurrence2Date?: string | null;
  occurrenceCode3Code?: string | null;
  occurrence3Date?: string | null;
  occurrenceCode4Code?: string | null;
  occurrence4Date?: string | null;
  valueCode1Code?: string | null;
  value1Amount?: number | null;
  valueCode2Code?: string | null;
  value2Amount?: number | null;
  valueCode3Code?: string | null;
  value3Amount?: number | null;
  conditionCode1Code?: string | null;
  conditionCode2Code?: string | null;
  conditionCode3Code?: string | null;
  conditionCode4Code?: string | null;
  conditionCode5Code?: string | null;
  conditionCode6Code?: string | null;
  conditionCode7Code?: string | null;
  conditionCode8Code?: string | null;
  conditionCode9Code?: string | null;
  conditionCode10Code?: string | null;
  conditionCode11Code?: string | null;
  diagnosis1Code?: string | null;
  diagnosis1PresentOnAdmission?: string | null;
  diagnosis2Code?: string | null;
  diagnosis2PresentOnAdmission?: string | null;
  diagnosis3Code?: string | null;
  diagnosis3PresentOnAdmission?: string | null;
  diagnosis4Code?: string | null;
  diagnosis4PresentOnAdmission?: string | null;
  diagnosis5Code?: string | null;
  diagnosis5PresentOnAdmission?: string | null;
  diagnosis6Code?: string | null;
  diagnosis6PresentOnAdmission?: string | null;
  diagnosis7Code?: string | null;
  diagnosis7PresentOnAdmission?: string | null;
  diagnosis8Code?: string | null;
  diagnosis8PresentOnAdmission?: string | null;
  diagnosis9Code?: string | null;
  diagnosis9PresentOnAdmission?: string | null;
  diagnosis10Code?: string | null;
  diagnosis10PresentOnAdmission?: string | null;
  diagnosis11Code?: string | null;
  diagnosis11PresentOnAdmission?: string | null;
  diagnosis12Code?: string | null;
  diagnosis12PresentOnAdmission?: string | null;
  issues?: Array<HoldingIssue> | null;
}
